/**
 * Checks if a key is options array of a query.
 *
 * @param {Object}                 options   Options to check.
 * @param {string}                 key       Key to check.
 * @param {"any" | "all" | "none"} condition Condition to check.
 * @return {number} index in filters
 */
export const getIndexInFilters = ( options, key, condition ) => {
	return options?.filters && options.filters[ condition ] ? options.filters[ condition ].findIndex( filter => Object.keys( filter )[ 0 ] === key ) : -1;
};
